import { jsx as _jsx } from "react/jsx-runtime";
import { Prompt } from "@coveord/plasma-mantine";
import { Locales } from "../../../strings/Locales";
export var DeleteSingleResourcePromptConfirmButton = function(param) {
    var onClick = param.onClick, loading = param.loading;
    return /*#__PURE__*/ _jsx(Prompt.ConfirmButton, {
        loading: loading,
        onClick: onClick,
        children: Locales.format("DeleteSingleResourcePrompt.footer.button.delete")
    });
};

//# sourceMappingURL=DeleteSingleResourcePromptConfirmButton.js.map